module.exports = __webpack_public_path__ + "static/img/jikeng.b25c200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cases/jikeng.png
// module id = Q9Df
// module chunks = 1